<h1 id='ehm-title' class="top-padding">智保網</h1>

<div style="text-align: left;">
  <a routerLink="../">返回</a>
</div>
<hr>
<div class="iframe-container">
  <iframe class="responsive-iframe" src="https://www.youtube.com/embed/UMScztU6Jn8" width="80%" height="auto" style="max-height:4000px;border:none;overflow:hidden" scrolling="no" frameborder="0" allowTransparency="true" data-show-text="true"  allow="encrypted-media" allowFullScreen="true"></iframe>
</div>

&nbsp;
<div class="row">

  <div class="col-lg-6">
    <h3>電子院舍管理</h3  >
    <p>
      <span class="highlight">智保管理系統: </span>
      藥物事故在醫院及老人院間不時發生，通常病人本身已經失去控制能力及主導權，要依賴醫護人員照顧，希望可以從病床中站起來。
      有鑑於此，我們研發了「一目了然」智保管理系統，幫助管理層、醫護人員及前線員工在執行藥物管理及派送藥物時，可以更迅速及更準確。
      我們將派藥的記錄電腦化，（包括為院舍建立藥物相片、藥物記錄、醫院診所及病人資料庫），配以電子記錄，利用智能手機、電子郵件及智能系統，將資料準確地儲存及記錄，提升準確度、效率及質素。
      另一方面，派藥時，利用智能手機作餵藥記錄，準確把派藥的員工記錄在案，方便管理層監測及跟進員工的工作記錄。
      智保管理系統為院舍提供更優質的服務，成為長者的良友，智能助護，照顧他們的服藥需要。
      智保管理系統已包含院舍管理系統及護理，PT，OT，社工，到訪家居及員工配對各項功能。已在醫管局及社署管轄下院舍廣泛使用。
    </p>
  </div>

  <div class="col-lg-6">
    <img class="img-fluid" src="assets/images/laptop_ehm.png" alt="智保®管理系統">
  </div>

</div>
<div id="ehm">
  <a id="med">
    <img  (click)="setPage(1)" src="assets/images/med-portal.png" />
  </a>
  <a id="hms">
    <img (click)="setPage(2)" src="assets/images/hms-portal.png" />
  </a>
  <a id="obs">
    <img  (click)="setPage(3)" src="assets/images/obs-portal.png" />
  </a>
  <a id="icp">
    <img  (click)="setPage(4)" src="assets/images/icp-portal.png" />
  </a>
  <a id="nhm">
    <img (click)="setPage(5)"src="assets/images/nhm-portal.png" />
  </a>
  <!-- <a id="cell">
    <img id="portal" (click)="setPage(6)"src="assets/images/kardex-portal.png" />
  </a> -->
  <a id="stat">
    <img  (click)="setPage(7)"src="assets/images/statistic-portal.png" />
  </a>
</div>

<div *ngIf='page == 0'>
  <h3 i18n="@@seeMore">

    ↑ See More↑
  </h3>
</div>

<div *ngIf='page == 1'>
  <div  class="med-bg" style="
  background-color: rgb(255, 216, 212);
  border-color: rgb(241, 169, 160);"
  >


    <h2>Medsupack</h2>

    <!-- <p> Medicine Management system with mobile device-aded drug administration and e-signature.</p>
     -->
     <div class="row">
      <div class="col-lg-6">
        <h3>電子藥物管理</h3>
        <div> <span class="highlight">智保藥物管理系統</span> 的獨有優點:</div>
        <ul>
          <li *ngFor="let advantage of advantageList"> {{advantage}} </li>
        </ul>
        <hr class="hiddenLines-lg">
      </div>

      <div class="col-lg-6">
        <img class="img-fluid" style="padding-left: 30px" src="assets/images/ehm_1.jpg" width="75%" alt="智保®管理系統">
      </div>


    </div>

    <hr>
    <h3>OCR 功能</h3>
    <div class="row">
      <div class="col-lg-6">
        <div class="container">


          <iframe class="rframe" width="100%" height="auto" src="https://www.youtube.com/embed/zNI1KvlGrDo">
          </iframe>
        </div>

      </div>

      <div class="col-lg-6">
        <img class="img-fluid" style="padding-left: 30px" src="assets/images/ehm_2.jpg" width="95%" alt="智保®管理系統">
      </div>



    </div>
    <hr>
    <button
      class='typeButton btn btn-outline-secondary'
      (click)="setPage(0)">
    Close
    </button>
    </div>
  </div>

<div *ngIf='page == 2'>

  <div class="med-bg" style="
  background-color: rgb(232, 255, 250);
  border-color: rgb(165, 217, 206);"
  >

    <h2 i18n="@@ehmHMSTitle">HMS 生命表徵記錄表</h2>
    <!-- <p i18n="@@ehmHMSText">Automatic recording of vital sign readings using Bluetooth and provide an institutional-level summary report.</p> -->

    <img src="assets/images/hms_1.png" width="60%" />

    <br/>

    <button
    class='typeButton btn btn-outline-secondary'
    (click)="setPage(0)">
  Close
  </button>
  </div>
</div>

<div *ngIf='page == 3'>
  <div class="med-bg" style="
  background-color: rgb(227, 250, 255);
  border-color: rgb(148, 215, 229);"
  >
    <h2 i18n="@@ehmObsTitle">Observations</h2>
    <p i18n="@@ehmObsText">Track and record daily living activities and wound care as the foundation of individualized and coordinated care.</p>
    <button
    class='typeButton btn btn-outline-secondary'
    (click)="setPage(0)">
  Close
  </button>
  </div>
</div>

<div *ngIf='page == 4'>
  <div class="med-bg" style="
  background-color: rgb(230, 227, 255);
  border-color: rgb(174, 169, 211);"
  >
    <h2  i18n="@@ehmICPTitle">Individualized Care Plan</h2>
    <p  i18n="@@ehmICPText">Evidence-based need/risk profiling algorithms are embedded to trigger tailered person-centered care planning.</p>
    <img src="assets/images/icp-01.png" width=100%/>
    <br/>
    <hr>
    <button
      class='typeButton btn btn-outline-secondary'
      (click)="setPage(0)">
    Close
    </button>
  </div>
</div>

<div *ngIf='page == 5'>
  <div class="med-bg" style="
  background-color: rgb(255, 234, 201);
  border-color: rgb(254, 204, 128);"
  >
    <h2 i18n="@@ehmNHMTitle">NHM Home & Center Management</h2>
    <p i18n="@@ehmNHMText">Cloud-based strategy to manage clients' accounts, invoices, summary report and system security.</p>
    <button
      class='typeButton btn btn-outline-secondary'
      (click)="setPage(0)">
    Close
    </button>
    </div>
  </div>

<div *ngIf='page == 6'>
  <div class="med-bg" style="
  background-color: rgb(230, 230, 230);
  border-color: rgb(206, 205, 205);"
  >
    <h2 i18n="@@ehmKARTitle">KARDEX</h2>
    <p i18n="@@ehmKARText">A module to produce electronic logs for activites management.</p>
    <button
      class='typeButton btn btn-outline-secondary'
      (click)="setPage(0)">
    Close
    </button>
  </div>
</div>

<div *ngIf='page == 7'>
  <div class="med-bg" style="
  background-color: rgb(232, 243, 252);
  border-color: rgb(209, 228, 245);"
  >
    <h2 i18n="@@ehmStatTitle">Statistics</h2>
    <p i18n="@@ehmStatText"></p>

    <button
      class='typeButton btn btn-outline-secondary'
      (click)="setPage(0)">
    Close
    </button>
  </div>
</div>



<app-ehm-info></app-ehm-info>
<!--
<div class="row">

  <div class="col-lg-6">
    <h3>電子院舍管理</h3>
    <p>
      <span class="highlight">智保管理系統: </span>
      藥物事故在醫院及老人院間不時發生，通常病人本身已經失去控制能力及主導權，要依賴醫護人員照顧，希望可以從病床中站起來。
      有鑑於此，我們研發了「一目了然」智保管理系統，幫助管理層、醫護人員及前線員工在執行藥物管理及派送藥物時，可以更迅速及更準確。
      我們將派藥的記錄電腦化，（包括為院舍建立藥物相片、藥物記錄、醫院診所及病人資料庫），配以電子記錄，利用智能手機、電子郵件及智能系統，將資料準確地儲存及記錄，提升準確度、效率及質素。
      另一方面，派藥時，利用智能手機作餵藥記錄，準確把派藥的員工記錄在案，方便管理層監測及跟進員工的工作記錄。
      智保管理系統為院舍提供更優質的服務，成為長者的良友，智能助護，照顧他們的服藥需要。
      智保管理系統已包含院舍管理系統及護理，PT，OT，社工，到訪家居及員工配對各項功能。已在醫管局及社署管轄下院舍廣泛使用。
    </p>
  </div>

  <div class="col-lg-6">
    <img class="img-fluid" src="assets/images/laptop_ehm.png" alt="智保®管理系統">
  </div>

</div>


<hr>
<div class="row">
  <div class="col-lg-6">
    <h3>電子藥物管理</h3>
    <div> <span class="highlight">智保藥物管理系統</span> 的獨有優點:</div>
    <ul>
      <li *ngFor="let advantage of advantageList"> {{advantage}} </li>
    </ul>
    <hr class="hiddenLines-lg">
  </div>
  <div class="col-lg-6">
    <h3>基金協助</h3>
    <p> 我們附屬的 <span style="color:orange;">科學園</span> 智慧集成公司 可以為貴公司申請以下基金: </p>

    <div class="trustBox">
      <a href="https://www.swd.gov.hk/tc/index/site_pubsvc/page_supportser/sub_itfund/">
        樂齡科技基金
      </a>

    </div>
    <div class="trustBox">
      <a href="https://www.itf.gov.hk/l-tc/tvp.asp">
        科技劵
      </a>
    </div>
    <div class="trustBox">
      <a href="https://fbl.itb.gov.hk/">
        創科生活基金
      </a>
    </div>

  </div>
</div>

<hr>
<div class="row">
  <div class="col-lg-6">
    <div class="container">

      <h3>OCR 功能</h3>
      <iframe class="rframe" width="100%" height="auto" src="https://www.youtube.com/embed/zNI1KvlGrDo">
      </iframe>
    </div>

  </div>
</div> -->

<hr>
<h2>產品榮譽</h2>
<div class="row">
  <div class="col-lg-6">
    <div class="card">
      <div class="card-body">
        <h3 class="card-title">資訊科技初創企業獎 2018</h3>
        <p class="card-text">
          智保藥物管理系統在2018香港資訊及通訊科技獎 (社會貢獻範疇) 得到銅獎。
        </p>
      </div>

      <a routerLink="./ICT2018">
        <img class="card-img-bottom" src="assets/images/ICT2018.jpg" alt="">
      </a>
    </div>
  </div>
</div>
